import { useTranslation } from 'react-i18next';
import { List, ListItem } from '@mui/material';
import { useFuelEfficiencyFilter } from 'lib/hooks/useSrpFilters';
import { SrpFuelEfficiencyValue } from 'types/srpFilters';
import DropdownContainer from 'components/Shared/SearchFilter/DropdownContainer';
import ModalDropdownContainer from 'components/Shared/SearchFilter/ModalDropdownContainer';
import { screen } from 'components/styles/variables';
import useEvents from 'lib/hooks/useEvents';
import FuelEfficiencyTap from 'lib/Tracking/Srp/SearchFilters/EngineFilter/FuelEfficiencyTap';
import { useContext } from 'react';
import SrpEventContext from 'contexts/SrpEventContext';
import { useStyles } from './styles';

export default function FuelEfficiencyDropdownFilter(): JSX.Element {
  const { t } = useTranslation();

  const { value } = useFuelEfficiencyFilter();

  const menu = <FuelEfficiencyMenu />;

  const title = value
    ? `${t('srp.filters.fuelEfficiency.option', { value })}`
    : t('srp.filters.fuelEfficiency.title');

  return (
    <>
      <div className="fuel-efficiency-modal-container">
        <ModalDropdownContainer placeHolderTitle={title}>{menu}</ModalDropdownContainer>
      </div>

      <div className="fuel-efficiency-dropdown-container">
        <DropdownContainer title={title} resetsOnClose>
          {menu}
        </DropdownContainer>
      </div>

      <style jsx>{`
        .fuel-efficiency-modal-container {
          display: flex;
          flex-direction: column;
        }

        @media (min-width: ${screen.mobileMax}) {
          .fuel-efficiency-modal-container {
            display: none;
          }
        }

        @media (max-width: ${screen.mobileMax}) {
          .fuel-efficiency-dropdown-container {
            display: none;
          }
        }
      `}</style>
    </>
  );
}

interface FuelEfficiencyMenuProps {
  onListItemClick?: (value: string) => void;
  setIsModalOpen?: (value: boolean) => void; // injected by ModalDropdownContainer
}

function FuelEfficiencyMenu({
  onListItemClick,
  setIsModalOpen,
}: FuelEfficiencyMenuProps): JSX.Element {
  const { t } = useTranslation();
  const logger = useEvents();
  const { sourcePage } = useContext(SrpEventContext);
  const { value, setValue } = useFuelEfficiencyFilter();

  const fuelEfficiencyOptions = [
    { value: 0, label: t('srp.filters.fuelEfficiency.title') },
    { value: 20, label: t('srp.filters.fuelEfficiency.option', { value: 20 }) },
    { value: 30, label: t('srp.filters.fuelEfficiency.option', { value: 30 }) },
    { value: 40, label: t('srp.filters.fuelEfficiency.option', { value: 40 }) },
    { value: 50, label: t('srp.filters.fuelEfficiency.option', { value: 50 }) },
  ];

  const classes = useStyles();

  return (
    <List className={classes.radiusModal} role="button">
      {fuelEfficiencyOptions.map((option, index) => {
        function handleClick(): void {
          onListItemClick?.(option.label);
          setValue(option.value as SrpFuelEfficiencyValue);
          setIsModalOpen?.(false);
          logger.log(FuelEfficiencyTap({ sourcePage }));
        }

        const isSelected = value === option.value;

        return (
          <ListItem
            key={index}
            className={classes.listItem}
            onClick={handleClick}
            selected={isSelected}
            classes={{ selected: classes.selected }}
          >
            {isSelected && <div className={classes.selectedIcon} />}
            {option.label}
          </ListItem>
        );
      })}
    </List>
  );
}
